import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const NEW_TASK_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: true,
  width: "1200px",
  height: "850px",
};
